// extracted by mini-css-extract-plugin
export default {"main":"ImageNotMove_main__4F6dj","main1":"ImageNotMove_main1__EsckL","exstra":"ImageNotMove_exstra__mPqC9","main2":"ImageNotMove_main2__saUaF"};